import { TRIGGER_FETCH_PREPAID_TXN_LIST_API, TRIGGER_FETCH_PREPAID_TXN_LIST_API_SUCCESS } from 'redux/actionTypes';

export function triggerFetchPrePaidTxnListApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_PREPAID_TXN_LIST_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchPrePaidTxnListApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_PREPAID_TXN_LIST_API_SUCCESS,
		data,
	};
}
